import http from './http.service';

class OrgModelService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/organizationalModel";
    }

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/get/${id}`);
    };

    getValidModels(eventId, overrideOrganizationalCalendarSettings, customOrganizationalCalendarSettings) {
        if (!eventId) {
            throw new Error('EventId is required');
        }

        const params = {
            eventId,
            overrideOrganizationalCalendarSettings,
            loadOnlyValidModels: customOrganizationalCalendarSettings ? customOrganizationalCalendarSettings.loadOnlyValidModels : null,
            calendarModelsANDFilter: customOrganizationalCalendarSettings ? customOrganizationalCalendarSettings.calendarModelsANDFilter : null
        };
        return this.$http.get(`${this.baseUrl}/validModelsForEvent`, { params });
    }

    // loadForEvent(eventId) {
    //    if (!eventId) {
    //        throw new Error('EventId is required');
    //    }

    //    return this.$http.get(`${this.baseUrl}/loadForEvent/${eventId}`);
    // }

    // create(model) {
    //    if (!model) {
    //        throw new Error('Model is required');
    //    }

    //    return this.$http.post(`${this.baseUrl}`, model);
    // };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}/updateModel`, model);
    };

    activate(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/activate`, { params: { id: id } });
    };

    deactivat(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}/deactivate`, { params: { id: id } });
    };

    getOrganizationalCalendarSettings() {
        return this.$http.get(`${this.baseUrl}/getOrganizationalCalendarSettings`);
    };
}

export default new OrgModelService();
